import { createFileRoute } from '@tanstack/react-router';
import ActivitiesManagement from '../../components/manager/ActivitiesManagement';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/activities')({
  component: StaffActivitiesRoute,
});

function StaffActivitiesRoute() {
  return (
    <StaffPortal>
      <ActivitiesManagement />
    </StaffPortal>
  );
}
